import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from "@auth0/auth0-react";

ReactDOM.render(
    <Auth0Provider
      domain="dev-1g0jiql9.eu.auth0.com"
      clientId="QQ05GzYCYxRJNBGKZpdukU4rLDov1BoH"
      authorizationParams={{
        audience: "https://portal.endpoints.lauwers.cloud.goog",
        redirect_uri :window.location.origin,
      }}
      
    >
      <App />
    </Auth0Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
